import { render, staticRenderFns } from "./source_branch_removal_status.vue?vue&type=template&id=444ce060&"
import script from "./source_branch_removal_status.vue?vue&type=script&lang=js&"
export * from "./source_branch_removal_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "source_branch_removal_status.vue"
export default component.exports